import {
  Button,
  Divider,
  Row,
  Select,
  Space,
  Popconfirm,
  Typography,
  Input,
  Card,
  Tag,
  ConfigProvider,
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import React from "react";
import "./styles.css";
import { TrainingAPI } from "../../api/TrainingAPI";
import { formattedPlayerName } from "../../Utils/name_utils";
import { useSelector } from "react-redux";
import {
  AppstoreAddOutlined,
  UserOutlined,
  DeleteOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "../../Styles/styles-Settings.css";
import { useDispatch } from "react-redux";
import {
  setTeamPlayerGroups,
  setTeamPlayers,
} from "../../store/actions/team.actions";
import { PermissionedInput, PermissionedButton, PermissionedSelect, PermissionedPopConfirm} from '../PermissionedComponents';
import {PlayerOptions} from "@components/Common/PlayerOptions";

const { Search } = Input;
const { Title } = Typography;
const { CheckableTag } = Tag;

const trainingAPI = new TrainingAPI();

export const PlayerGrouping = () => {
  const dispatch = useDispatch();
  const {
    playerGroups,
    players,
    info : { display_name: teamName },
    playersStatus
  } = useSelector(({ team }) => team);

  const inputRef = React.useRef(null);

  const handleCreateNewGroup = () => {
    if (!inputRef.current || !inputRef.current.input) {
      message.error("Input field is not available");
      return;
    }
    const newGroupName = inputRef.current.input.value;
    if (newGroupName === "") {
      message.info("Group name can't be empty.");
      return;
    }
    trainingAPI
      .createPlayerGroup(newGroupName)
      .then((data) =>
        dispatch(setTeamPlayerGroups([...playerGroups].concat(data)))
      )
      .catch((err) => message.error(err));
  };
  const handleDeleteGroup = (name) => {
    trainingAPI
      .deletePlayerGroup(name)
      .then((data) => {
        dispatch(
          setTeamPlayerGroups(playerGroups.filter((x) => x.name !== name))
        );
        message.success("Player group deleted.");
      })
      .catch((err) => {
        console.log(err);
        message.error("Error");
      });
  };

  const addPlayerToGroup = (player_id, group) => {
    let newPlayers = players.map((item) =>
      item?.player_id == player_id
        ? {
            ...item,
            player_groups: [
              ...(item?.player_groups ?? []),
              group.player_group_id,
            ],
          }
        : item
    );
    trainingAPI
      .updatePlayerGroupMapping(player_id, group.name, "add")
      .then((data) => {
        dispatch(setTeamPlayers(newPlayers));
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const removePlayerFromGroup = (player_id, group) => {
    let newPlayers = players.map((item) => {
      if (
        item?.player_id == player_id &&
        item?.player_groups?.includes(group.player_group_id)
      ) {
        let idx = item?.player_groups?.indexOf(group.player_group_id);
        item?.player_groups.splice(idx, 1);
      }
      return item;
    });

    trainingAPI
      .updatePlayerGroupMapping(player_id, group.name, "del")
      .then((data) => {
        dispatch(setTeamPlayers(newPlayers));
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const filterOption = (input, option) => {
    return (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        margin: "0px 0px 24px",
      }}
    >
      <Space>
        <Space.Compact>
          <PermissionedInput 
            permissionCheck="AddPlayerGroups"
            placeholder="Add new Group" 
            ref={inputRef} 
          />
          <PermissionedButton
            permissionCheck="AddPlayerGroups"
            type="primary"
            icon={<AppstoreAddOutlined />}
            onClick={handleCreateNewGroup}
          />
        </Space.Compact>
      </Space>
      <Row
        style={{
          display: "flex",
          flexWrap: "wrap",
          // justifyContent: 'space-evenly',
          // border: '1px solid black',
          gap: "1em",
          marginTop: 16
        }}
      >
        {playerGroups.map((group, i) => (
          <>
            <Card
              extra={
                <>
                  <Tag style={{ border: "none" }} icon={<UserOutlined />}>
                    {
                      players.filter((item) =>
                        item?.player_groups?.includes(group.player_group_id)
                      ).length
                    }
                  </Tag>
                  <PermissionedPopConfirm
                    permissionCheck="DeletePlayerGroups"
                    placement="bottom"
                    title="Are you sure you want to delete this group?"
                    onConfirm={() => handleDeleteGroup(group.name)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <PermissionedButton 
                      permissionCheck="DeletePlayerGroups"
                      size={"small"} 
                      icon={<DeleteOutlined />}
                    />
                  </PermissionedPopConfirm>
                </>
              }
              title={<div style={{ textAlign: "left" }}>{group.name}</div>}
            >
              <PermissionedSelect
                permissionCheck="EditPlayerGroups"
                placeholder="Add Player"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                style={{ width: "100%" }}
                onSelect={(player_id) => {
                  addPlayerToGroup(player_id, group);
                }}
              >
                {players
                  .sort((a, b) => a.first_name.localeCompare(b.first_name))
                  .map((player, i) => {
                  return PlayerOptions({ player, teamName, index: i, playersStatus});
                })}
              </PermissionedSelect>
              <Divider />
              <div
                style={{
                  maxHeight: "10em",
                  overflowY: "scroll",
                  width: "20em",
                }}
              >
                {players
                  .filter((item) =>
                    item?.player_groups?.includes(group.player_group_id)
                  )
                  .map((item) => (
                    <>
                      <div
                        className="player-group-list-item"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          padding: "2px",
                        }}
                      >
                        <div>
                          {item.first_name} {item.last_name} - {item.position}
                        </div>
                        <div>
                          <PermissionedButton
                            permissionCheck="EditPlayerGroups"
                            size="small"
                            shape="circle"
                            type="text"
                            style={{
                              backgroundColor: "#fff",
                              marginRight: "0.5em",
                            }}
                            icon={
                              <CloseOutlined className="player-group-list-item-button" />
                            }
                            onClick={() => {
                              removePlayerFromGroup(item.player_id, group);
                            }}
                          />
                        </div>
                      </div>
                    </>
                  ))}
              </div>
            </Card>
          </>
        ))}
      </Row>
    </div>
  );
};
